import { render, staticRenderFns } from "./LessonQuestion.vue?vue&type=template&id=8cc0e8d8&scoped=true&"
import script from "./LessonQuestion.vue?vue&type=script&lang=js&"
export * from "./LessonQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LessonQuestion.vue?vue&type=style&index=0&id=8cc0e8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc0e8d8",
  null
  
)

export default component.exports